export enum ESettingsSection {
  PROFILE = "profile",
  CHAT = "chat",
  ORGANIZATION = "organization",
}

export enum EProfileTab {
  GENERAL_INFORMATION = "generalInformation",
  BILLING = "billing",
  PREFERENCES = "preferences",
  // NOTE: NSAI-6657 — the project's Models page (default models, per-project
  // visibility, custom models), moved here from its own sidebar route.
  MODELS = "models",
  MEMORY_INSTRUCTIONS = "memoryInstructions",
  MEMORY = "memory",
  CALENDAR = "calendar",
  API_KEYS = "apiKeys",
  BOT_SETTINGS = "botSettings",
  HISTORY = "history",
  SHARED_CHATS = "sharedChats",
  TOKEN_USAGE = "tokenUsage",
}

export enum EOrganizationTab {
  GENERAL = "general",
  ROLES = "roles",
  PROJECTS = "projects",
  MODELS = "models",
  MEMBERS = "members",
  API_KEYS = "api_keys",
  SAML = "saml",
  INTEGRATION = "integration",
  CONNECTOR_APPROVAL = "connector_approval",
  CHAT_SETTINGS = "chat_settings",
  CALL_ASSISTANT = "call_assistant",
  SYNCATOR_API_KEYS = "syncator_api_keys",
  APPEARANCE = "appearance",
  BILLING = "billing",
  HISTORY = "history",
  TOKEN_USAGE = "token_usage",
  DATA_RETENTION = "data_retention",
  DOC_RECOGNITION = "doc_recognition",
  SIEM_EXPORT = "siem_export",
  // NOTE: NSAI-6369 — the categories memory must never store about any member
  // of this workspace. Gated on the memory_policy family, not on ownership.
  MEMORY_POLICY = "memory_policy",
  // NOTE: NSAI-7442 — the organization's External API (/v1) limit rules.
  // Gated on the external_api_limits family and on the External API being on.
  EXTERNAL_API_LIMITS = "external_api_limits",
}

// NOTE: NSAI-5293 — the three former top-level entries (Token Usage, Token &
// Cost Usage, Usage Limits) are now panes of ONE "Token Usage" section. The
// organization section carries all three; the profile section has no limits of
// its own, so it renders only USAGE and COST.
export enum ETokenUsagePane {
  USAGE = "usage",
  COST = "cost",
  LIMITS = "limits",
  // NOTE: NSAI-8010 — per-user usage, trends and spikes. Organization-only.
  USER_ANALYTICS = "user-analytics",
}

export enum ESettingsQueryParams {
  SECTION = "section",
  TAB = "tab",
  // NOTE: NSAI-5293 — which pane of the merged Token Usage section is open, so
  // a pane is linkable and survives a reload (AC 7). Kept separate from TAB so
  // the section itself keeps one stable tab id in the URL.
  USAGE_TAB = "usage-tab",
  ORGANIZATION_UUID = "organization-uuid",
  PROJECT_UUID = "project-uuid",
  CREATE_ORGANIZATION = "create-organization",
}
